import { Modal } from 'components';
import errorIcon from 'assets/img/error-icon.svg';
import successIcon from 'assets/img/iconregalo.svg';

export default function ResponseModal({
  show,
  title,
  message,
  code,
  onClose,
  onSubmit,
  success,
  titleHeader,
  ...props
}) {
  return (
    <>
      <Modal
        icon={success ? successIcon : errorIcon}
        titleHeader= {titleHeader ? titleHeader : ''}
        onClose={onClose}
        onSubmit={onSubmit}
        show={show}
        title={title}
        titleClassName="text-center"
        subtitle={message}
        subtitleClassName="text-center my-4"
        code={code}
        codeClassName="text-center my-4"
        centered
        type="response"
        {...props}
      />
    </>
  );
}
